import React from 'react';
import { ds } from '../../design-system';
import AppButton from './AppButton';

/**
 * Shared search + filter toolbar for admin list pages.
 * Filter field changes only update local state — Apply / Clear trigger fetch.
 */
export default function ListToolbar({
  search,
  onSearchChange,
  searchPlaceholder = 'Search…',
  onApply,
  applyLabel = 'Apply Filters',
  onClear,
  clearLabel = 'Clear Filters',
  children,
  header,
  footer,
  className = '',
}) {
  return (
    <div className={`${ds.card} p-4 space-y-3 ${className}`}>
      {header || null}
      <div className="flex flex-wrap gap-2 items-end">
        {onSearchChange != null ? (
          <div className="flex-1 min-w-[160px]">
            <label className={ds.label}>Search</label>
            <input
              value={search ?? ''}
              onChange={(e) => onSearchChange(e.target.value)}
              placeholder={searchPlaceholder}
              className={ds.input}
            />
          </div>
        ) : null}
        {children}
        {onApply ? (
          <AppButton type="button" variant="primary" icon="search" onClick={onApply}>
            {applyLabel}
          </AppButton>
        ) : null}
        {onClear ? (
          <AppButton type="button" variant="secondary" icon="x" onClick={onClear}>
            {clearLabel}
          </AppButton>
        ) : null}
      </div>
      {footer || null}
    </div>
  );
}

export function ToolbarField({ label, children, className = '' }) {
  return (
    <div className={className}>
      {label ? <label className={ds.label}>{label}</label> : null}
      {children}
    </div>
  );
}
